import Vue from 'vue';
import VueRouter from 'vue-router';
import {
  omit,
  capitalize,
} from 'lodash';

import {
  QUERIES_TO_KEEP,
} from '@/constants/common';
import {
  getPageUrlPrefix,
} from '@/helpers/common';

Vue.use(VueRouter);

const hasQueryParams = ({ query }) => Object.keys(query).some(q => QUERIES_TO_KEEP.includes(q));

const getPages = require.context(
  '../views/',
  true,
  /(Page)([a-zA-Z/.]*)\.vue$/,
  'lazy',
);

const getProductRouterComponents = (productName, isLeadgen) => {
  const productCategory = isLeadgen ? 'lg' : productName;

  return getPages.keys().reduce((accumulator, filePath) => {
    const parts = filePath.split('/').splice(1);

    const componentName = parts[parts.length - 1].replace('.vue', '');
    const componentCategory = parts[0].toLocaleLowerCase();

    if (componentCategory === productCategory) {
      const componentConfig = getPages(filePath);
      accumulator[componentName] = () => componentConfig;
    }

    return accumulator;
  }, {});
};

const createProductRoutes = (productName, isLeadgen, componentConfig) => {
  return [
    {
      path: '',
      name: `${productName}-insurance`,
      component: componentConfig[`Page${(isLeadgen) ? 'Lg' : capitalize(productName)}Insurance`],
    },
    {
      path: '/:sid',
      name: `${productName}-insurance-results`,
      component: componentConfig[`Page${(isLeadgen) ? 'Lg' : capitalize(productName)}InsuranceResults`],
    },
  ];
};

export const initRouter = (productName, isLeadgen) => {
  const componentConfig = getProductRouterComponents(productName, isLeadgen);
  const productRoutes = createProductRoutes(productName, isLeadgen, componentConfig);
  const router = new VueRouter({
    mode: 'history',
    base: `/${getPageUrlPrefix(productName, isLeadgen)}-insurance-ui/`,
    routes: productRoutes,
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },
  });

  router.beforeEach((to, from, next) => {
    if (hasQueryParams(from) && !hasQueryParams(to)) {
      let query = { ...from.query, ...to.query }; // merge query params to set correct step

      const isNextStepResultsPage = to.name === `${getPageUrlPrefix(productName, isLeadgen)}-insurance-results`;

      // remove 'step' query param if go to results page
      if (isNextStepResultsPage) {
        query = omit(query, 'step');
      }

      const result = {
        name: to.name,
        params: to.params,
        query,
      };

      next(result);
    } else {
      next();
    }
  });

  return router;
};
